import React, { FC } from "react";

import { UploadFileForm } from "~/features/uploadData/shared";
import { useUploadDealersMutation } from "~/schemas/generated/graphql";
import type { UploadDataFormProps } from "~/widgets/UploadDataModal";

const UploadDealersForm: FC<UploadDataFormProps> = (props) => (
  <UploadFileForm {...props} useUploadMutation={useUploadDealersMutation} />
);

export default UploadDealersForm;
